module.exports = __webpack_public_path__ + "img/img18.cf395b96.png";